<template>
  <div id="app">
    <div id="loader">

      <div class="showbox">
        <div class="loader">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
          </svg>
        </div>
      </div>

    </div>

    <div id="weebox-notice-success">

      <div class="showbox">
        <div class="loader">
          <svg version="1.1" class="tick-saved" viewBox="0 0 37 37">
            <path class="circ path" style="fill:none;stroke:#000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;" d="
              M30.5,6.5L30.5,6.5c6.6,6.6,6.6,17.4,0,24l0,0c-6.6,6.6-17.4,6.6-24,0l0,0c-6.6-6.6-6.6-17.4,0-24l0,0C13.1-0.2,23.9-0.2,30.5,6.5z"
            />
            <polyline class="tick path" style="fill:none;stroke:#000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;" points="
              11.6,20 15.9,24.2 26.4,13.8 "/>
          </svg>
        </div>
      </div>

    </div>


    <div id="weebox-export-inprogress">
      <div v-for="file in $store.getters.ApiExportPreviousRequests">
        <div class="image">
          <img :src="'/src/assets/images/file-' + file.name.split('.').pop().toLowerCase() + '.png'"/>
        </div>
        <div class="content">
          <div>
            <strong>Export en cours</strong>
            <p :title="file.url">{{ file.name }}</p>
          </div>
          <div>
            <button @click="file.cancel(file.index)"><i class="icon icon-icon_close"></i></button>
          </div>
        </div>
      </div>
    </div>

    <div id="weebox-notice">
      <span id="weebox-notice-message"></span>
      <span class="close"><i class="icon icon-icon_close"></i></span>
    </div>
    <!--
    <div class="authenticate-status" v-bind:class="{authenticated: $store.getters.isLoggedIn}"></div>
    -->
    <router-view v-if="$store.getters.loaded"></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  data () {
      return{
          msg: 'Welcome to Your Vue.js App'
      }
  },
  mounted() {
    /*
    var test = "2022-09-14T18:38:00.000000Z";
    var date = new Date(test);
    alert(date.getHours() + " - " + date.getUTCHours())
    alert(date.getTimezoneOffset())
    */
  },
  methods:{
  }
}
</script>

<style lang="scss">
  @import './sass/base';
</style>



// WEBPACK FOOTER //
// src/App.vue